import { render, staticRenderFns } from "./general-insurance-overview.vue?vue&type=template&id=3fff8b71"
import script from "./general-insurance-overview.vue?vue&type=script&lang=ts"
export * from "./general-insurance-overview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports